/** Проекты (§51). */
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { AdminProjectRow } from '@alterium/shared';
import { adminApi } from '../../api/admin';
import { DataTable, type Column } from '../../components/admin/DataTable';
import { formatDate } from '../../i18n/format';
import { useTranslation } from 'react-i18next';

export function AdminProjectsPage() {
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const [query, setQuery] = useState('');

  const projects = useQuery({
    queryKey: ['admin', 'projects', page, query],
    queryFn: () => adminApi.projects({ page, query }),
  });

  const columns: Array<Column<AdminProjectRow>> = [
    { key: 'title', title: t('admin.project.title'), render: (row) => row.title },
    { key: 'owner', title: t('admin.project.owner'), render: (row) => row.ownerEmail },
    { key: 'status', title: t('admin.job.status'), render: (row) => row.statusLabel },
    { key: 'scenes', title: t('admin.project.scenes'), render: (row) => row.sceneCount, align: 'right' },
    {
      key: 'problems',
      title: t('admin.project.problems'),
      align: 'right',
      render: (row) => (
        <span className={row.problemScenes > 0 ? 'text-error' : 'text-content-muted'}>
          {row.problemScenes}
        </span>
      ),
    },
    { key: 'estimated', title: t('admin.project.estimate'), render: (row) => row.estimatedUnits, align: 'right' },
    { key: 'spent', title: t('admin.job.spent'), render: (row) => row.spentUnits, align: 'right' },
    {
      key: 'created',
      title: t('admin.project.created'),
      render: (row) => formatDate(row.createdAt),
    },
  ];

  return (
    <div className="flex flex-col gap-4">
      <input
        value={query}
        onChange={(event) => {
          setQuery(event.target.value);
          setPage(1);
        }}
        placeholder={t('admin.project.searchPlaceholder')}
        className="h-9 w-64 rounded-control border border-line bg-surface px-3 text-meta text-content placeholder:text-content-muted focus:border-accent focus:outline-none"
      />

      <DataTable
        columns={columns}
        rows={projects.data?.items ?? []}
        rowKey={(row) => row.id}
        total={projects.data?.total}
        page={page}
        totalPages={projects.data?.totalPages}
        loading={projects.isLoading}
        onPage={setPage}
      />
    </div>
  );
}
